import * as React from 'react';
import { useEffect } from 'react';
import { Navigate, Outlet } from 'react-router-dom';
import './tokens.css';
import useAuth from '@/src/Authentication/components/hooks/useAuth';
import OrgContext from '@/src/Authentication/components/OrgContext';
import FeatureFlagContext from '@/src/Features/components/FeatureFlagContext';
import useFeatureFlags from '@/src/Features/components/hooks/useFeatureFlags';
import { useLocalStorage } from '@/src/Common/components/hooks/useLocalStorage';

/*
 * V2Frame — gate + providers for all /v2 routes, a peer of the classic
 * Layout: OrgContext (same 'current-org' storage key, so org selection
 * stays in sync with the classic app) and FeatureFlagContext. Chrome
 * lives in V2AppChrome / V2EventChrome via V2Shell.
 */

/* the classic dashboard population: Admin, User, GlobalAdmin */
const V2_ROLES = [0, 1, 69];

export default function V2Frame() {
    const { auth } = useAuth();
    const orgs = auth?.orgs;
    const [org, setOrg] = useLocalStorage('current-org', orgs?.[0]);

    useEffect(() => {
        const orgStillValid = orgs?.find((o: any) => o.id === org?.id);
        if (!orgStillValid) {
            setOrg(orgs?.[0]);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [orgs]);

    /* /v2 lives outside the classic Layout, so gate by role directly.
       Moves to a dedicated WEB_V2 flag at rollout. */
    if (!auth?.roles?.some((role: number) => V2_ROLES.includes(role))) {
        return <Navigate to="/home" replace />;
    }

    return (
        <OrgContext.Provider value={{ org, setOrg }}>
            <V2Flags />
        </OrgContext.Provider>
    );
}

function V2Flags() {
    const { featureFlags, isLoading } = useFeatureFlags();

    if (isLoading) {
        return (
            <div className="psv2 flex min-h-screen items-center justify-center">
                <span className="ps-label">Loading…</span>
            </div>
        );
    }

    return (
        <FeatureFlagContext.Provider value={featureFlags}>
            <Outlet />
        </FeatureFlagContext.Provider>
    );
}
